// Copyright 2020-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


export const BASE_URL = 'https://us-central1-riverman-e209b.cloudfunctions.net/api/'; //'https://9icjuwqg40.execute-api.ap-southeast-1.amazonaws.com/Prod/';

function getRequestHeader(token: string) {
  var header = new Headers();
  header.append("Authorization", `Bearer ${token}`);
  header.append("Content-Type", "application/json");
  return header
}

export async function fetchAreaCode(
  token: string,
  latitude: number,
  longitude: number
): Promise<any> {
  var requestOptions = {
    method: 'GET',
    headers: getRequestHeader(token)
  };

  const response = await fetch(
    `${BASE_URL}loc/${latitude}/${longitude}`,
    requestOptions
  );

  if (!response.ok) {
    return {};
  }

  const data = await response.json();

  if (data.error) {
    //throw new Error(`Server error: ${data.error}`);
    console.log(`Server error: ${data.error}`);
  }

  console.log("data:",data); 

  return data;
}

export async function fetchUsers(
  token: string
): Promise<any> {
  var requestOptions = {
    method: 'GET',
    headers: getRequestHeader(token)
  };

  const response = await fetch(
    `${BASE_URL}users`,
    requestOptions
  );

  if (!response.ok) {
    return {};
  }

  

  const data = await response.json();

  if (data.error) {
    //throw new Error(`Server error: ${data.error}`);
    console.log(`Server error: ${data.error}`);
  }

  return data;
}

export async function fetchUser(
  token: string,
  userId: string
): Promise<any> {
  var requestOptions = {
    method: 'GET',
    headers: getRequestHeader(token)
  };

  const response = await fetch(
    `${BASE_URL}users/${userId}`,
    requestOptions
  );

  if (!response.ok) {
    return {};
  }

  const data = await response.json();

  if (data.error) {
    //throw new Error(`Server error: ${data.error}`);
    console.log(`Server error: ${data.error}`);
  }

  return data;
}

export async function updateUser(
  token: string,
  userId: string,
  email: string,
  displayName: string,
  phoneNumber: string,
  role: string,
  trusted: Boolean
): Promise<any> {
  var requestOptions = {
    method: 'PATCH',
    headers: getRequestHeader(token),
    body: JSON.stringify({ email, displayName, phoneNumber, role, trusted })
  };

  const response = await fetch(
    `${BASE_URL}users/${userId}`,
    requestOptions
  );

  if (!response.ok) {
    return {};
  }

  const data = await response.json();

  if (data.error) {
    //throw new Error(`Server error: ${data.error}`);
    console.log(`Server error: ${data.error}`);
  }

  return data;
}

export async function createUser(
  token: string,
  email: string,
  displayName: string,
  phoneNumber: string,
  role: string,
  trusted: Boolean
): Promise<any> {
  var requestOptions = {
    method: 'POST',
    headers: getRequestHeader(token),
    body: JSON.stringify({ email, displayName, phoneNumber, role, trusted })
  };

  const response = await fetch(
    `${BASE_URL}users`,
    requestOptions
  );

  if (!response.ok) {
    return {};
  }

  const data = await response.json();

  if (data.error) {
    //throw new Error(`Server error: ${data.error}`);
    console.log(`Server error: ${data.error}`);
  }

  return data;
}